module.exports = __webpack_public_path__ + "img/TechInfantryArm3_ua.463f7047.webp";